import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { PageHeader, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { pageSectionTitle } from '../util/Style';
import { monthYearFromDate } from '../util/Util';

import { AgGridReact } from 'ag-grid-react';
import PaymentDetailsStore from '../stores/PaymentDetailsStore';
import PaymentDetailsSummary from './PaymentDetailsSummary';

const height = window.innerHeight * .65;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const columnDefs = [
    { headerName: '', field: 'select', width: 60, checkboxSelection: true, headerCheckboxSelection: true, pinned: 'left' },
    { headerName: 'Bucket', field: 'collectionType', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    {
        headerName: 'Status',
        field: 'PrintStatus',
        width: 90,
        pinned: 'left',
        type: 'numberColumn',
        cellStyle: params => {
            if (params.value === 1) {
                return { color: 'white', backgroundColor: 'rgb(27,160,97)' };
            }
            return { color: 'white', backgroundColor: 'rgb(204,47,16)' };
        }
    },
    { headerName: 'Date', field: 'InvoiceDate', width: 75, type: 'dateColumn' },
    { headerName: 'Number', field: 'InvoiceNumber', width: 100 },
    { headerName: 'Bill', field: 'BillTotal', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'IC', field: 'ICTotal', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
]

class PaymentDetails extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        const referrerId = props.params.referrerId;
        const collectionType = props.params.collectionType;
        this.store = new PaymentDetailsStore({ apiProxy: props.appStore.apiProxy, referrerId, collectionType });
        this.state = { isMerging: false };
    }

    fetchPayments = () => {
        this.store.fetchPayments(this.props.params.collectionType);
    }

    refreshGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    onRowClicked = async () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const number = selectedRows[0].InvoiceNumber;
        const date = selectedRows[0].InvoiceDate;
        const bucket = selectedRows[0].collectionType;
        const name = this.props.params.doctorName;

        const monthYear = monthYearFromDate(date);
        const period = bucket === 'daily' ? date.substr(0, 10) : monthYear;

        const invoiceHeader = { name, number, period };

        const url = await this.store.showInvoice(invoiceHeader);

        this.store.UpdateIcPrintStatus(number);

        window.open(url);
    }

    goBack = () => {
        const { collectionType } = this.props.params;
        this.props.appStore.currentComponent = {
            label: "Payments",
            key: "payments", // match the routing key used to load PaymentUI
            params: { collectionType } // this is now used in PaymentUI to pick the tab
        };
    }


    downloadSelectedPDFs = async () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();
        if (!selectedRows.length) return alert("Please select at least one row.");
        this.setState({ isMerging: true }); // show loader

        try {
            const result = await this.store.mergeInvoicesPdf(selectedRows, this.props.params.doctorName);
            if (!result || !result.blob) return alert("Error generating PDF");
            {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(result.blob);
                link.download = 'Merged_Invoices_' + new Date().toISOString().slice(0, 10) + '.pdf';
                link.click();

                const status = await this.store.UpdateMultipleIcPrintStatus(result.mergedInvoices);
                if (status === 'success') {
                    alert("Invoices downloaded and statuses updated successfully.");
                }

            }
        } catch (err) {
            console.error(err);
            alert("Error generating PDF");
        }
        finally {
            this.setState({ isMerging: false }); // hide loader
        }

    }

    render() {
        const doctorName = this.props.params.doctorName || " / Doctor Payment Details";
        return (
            <>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, background: "#fff", borderBottom: "1px solid #f0f0f0" }}>
                    <PageHeader backIcon={<ArrowLeftOutlined />} onBack={this.goBack} style={{ paddingTop: 0 }} title={pageSectionTitle(doctorName)} subTitle="Payment Details" />
                    <div style={{ display: "flex", padding: "12px 16px", gap: "10px", alignItems: "center" }}>
                        <Button type="primary" onClick={this.downloadSelectedPDFs} style={{ marginBottom: 10 }}>
                            Download Invoice
                        </Button>
                    </div>
                </div>
                {this.state.isMerging && (
                    <div className="loader-overlay">
                        <div className="loader">Generating Payment Invoice...</div>
                    </div>
                )}

                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={this.store.payments}
                        columnDefs={columnDefs}
                        rowSelection={'multiple'}
                        onRowClicked={this.onRowClicked}
                        onGridReady={this.fetchPayments}
                        rowHeight={25}>
                    </AgGridReact>
                    <div>
                        <PaymentDetailsSummary store={this.store} />
                    </div>
                </div>
            </>

        )
    }
}

export default observer(PaymentDetails)
